<template>
  <router-view></router-view>
</template>

<script>

export default {
  data() {
    return {}
  }
}
</script>

<style>
/* vue-directive-tooltip sets content via textContent, so honor \n line breaks.
   The library renders into .vue-tooltip / .vue-tooltip-content. */
.vue-tooltip,
.vue-tooltip .vue-tooltip-content,
.vue-tooltip .tooltip-content {
  white-space: pre-line;
}
</style>
